'use client';

import React from 'react';
import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import { useSession } from 'next-auth/react';

import { makeClient } from '@/apollo/ssrClient';

type Props = {
  children: React.ReactNode;
};

const ApolloProvider: React.FC<Props> = ({ children }) => {
  const { data } = useSession();

  return (
    <ApolloNextAppProvider makeClient={() => makeClient(data?.backendToken)}>
      {children}
    </ApolloNextAppProvider>
  );
};

export default ApolloProvider;
